import StopCircleRounded from '@mui/icons-material/StopCircleRounded';

export const StopTimeTrackingCircledIcon = StopCircleRounded;
